import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { poll } from '../../server';
import { logAPIError } from '../logger';
import { POLLING_INTERVAL, POLLING_MAX_RETRIES } from './constants';

const checkReadyRequest = async (revisionId) => {
    const url = pathfinder('logo_maker_makers_check_v_2_order_ready', { orderId: revisionId });
    const { data } = await axios.get(url);
    return data.data;
};

const checkDeliveryReady = async (
    revisionId,
    pollingInterval = POLLING_INTERVAL,
    pollingRetriesAmount = POLLING_MAX_RETRIES
) => {
    try {
        return await poll({
            action: () => checkReadyRequest(revisionId),
            exitCondition: (response) => !!response,
            pollingInterval,
            pollingRetriesAmount,
        });
    } catch (e) {
        logAPIError(e, {
            message: `Error while polling delivery ready status for revision: ${revisionId}`,
            revisionId,
        });
    }

    return false;
};

export default checkDeliveryReady;
